module.exports = __webpack_public_path__ + "img/28.6e00edad.jpg";